import { _ as C } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.promise.resolve-c679daba.js";
import "./es.string.link-fd2676c6.js";
import "./es.string.small-23219181.js";
import p, { createElement as I } from "react";
import g from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as z } from "./getMetrics-953aa4f8.js";
import { jsx as m } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./environment-is-node-a035d787.js";
import "./environment-ddee5959.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./iterate-13ada9e5.js";
import "./set-species-5ede2ed0.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./an-instance-6efcfd6c.js";
import "./species-constructor-00346775.js";
import "./function-apply-4756dee6.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./safe-get-built-in-a8d8c20c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./string-html-forced-a746405b.js";
import "./object-to-array-0474b7e7.js";
import "./array-method-is-strict-e5a3c878.js";
var S = ["$size"], W = ["size"], w = ["size"], U = /* @__PURE__ */ g.div.withConfig({
  displayName: "list__ListWrapper",
  componentId: "uv93mz-0"
})(["ol{margin-inline-start:", ";margin-inline-end:", " !important;padding-inline-start:", " !important;padding-inline-end:", " !important;list-style-position:", ";li span.ordered{padding-left:", " !important;}li ol,li ul{margin-top:", ";margin-inline-start:", " !important;}font-family:", ";font-style:", ";}ul{margin-inline-start:", " !important;margin-inline-end:", " !important;padding-inline-start:", " !important;padding-inline-end:", " !important;font-family:", ";font-style:", ";}li{position:", ";margin-bottom:", ";}li:last-of-type{margin-bottom:", ";}li ul{margin-inline-start:", " !important;margin-inline-end:", " !important;}"], function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.marginInlineStart;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.marginInlineEnd;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.paddingInlineStart;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.paddingInlineEnd;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.listStylePosition;
}, function(t) {
  var n = t.$size, e = t.theme;
  return n === "small" ? e == null ? void 0 : e.components.list.ListWrapper.ol.li.paddingLeft.small : n === "large" ? e == null ? void 0 : e.components.list.ListWrapper.ol.li.paddingLeft.large : e == null ? void 0 : e.components.list.ListWrapper.ol.li.paddingLeft.default;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.li.ol.marginTop;
}, function(t) {
  var n, e, i, o = t.$size, l = C(t, S);
  return o === "small" ? l == null || (n = l.theme) == null ? void 0 : n.components.list.ListWrapper.ol.li.ol.marginInlineStart.small : o === "large" ? l == null || (e = l.theme) == null ? void 0 : e.components.list.ListWrapper.ol.li.ol.marginInlineStart.large : l == null || (i = l.theme) == null ? void 0 : i.components.list.ListWrapper.ol.li.ol.marginInlineStart.default;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.fontFamily;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.fontStyle;
}, function(t) {
  var n = t.$type, e = t.theme;
  return n === "none" ? e == null ? void 0 : e.components.list.ListWrapper.ul.marginInlineStart.none : e == null ? void 0 : e.components.list.ListWrapper.ul.marginInlineStart.default;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ul.marginInlineEnd;
}, function(t) {
  var n = t.$size, e = t.$type, i = t.theme;
  return e === "none" ? i == null ? void 0 : i.components.list.ListWrapper.ul.paddingInlineStart.none : n === "large" ? i == null ? void 0 : i.components.list.ListWrapper.ul.paddingInlineStart.large : i == null ? void 0 : i.components.list.ListWrapper.ul.paddingInlineStart.default;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ul.paddingInlineEnd;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ul.fontFamily;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.ul.fontStyle;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.li.position;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.li.marginBottom;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.li.lastOfType;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.li.ul.marginInlineStart;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListWrapper.li.ul.marginInlineEnd;
}), $ = /* @__PURE__ */ g.ul.withConfig({
  displayName: "list__UnorderedListContainer",
  componentId: "uv93mz-1"
})(["list-style:", ";", ";", ""], function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.UnorderedListContainer.listStyle;
}, function(t) {
  var n = t.size, e = C(t, W);
  if (n === "small") {
    var i, o, l, r;
    return `
          font-family: ` + (e == null || (i = e.theme) == null ? void 0 : i.components.list.UnorderedListContainer.textStyle[n].fontFamily) + `; 
          font-weight: ` + (e == null || (o = e.theme) == null ? void 0 : o.components.list.UnorderedListContainer.textStyle[n].fontWeight) + `; 
          font-size: ` + (e == null || (l = e.theme) == null ? void 0 : l.components.list.UnorderedListContainer.textStyle[n].fontSize) + `; 
          line-height: ` + (e == null || (r = e.theme) == null ? void 0 : r.components.list.UnorderedListContainer.textStyle[n].lineHeight) + `;
      `;
  } else if (n === "medium") {
    var d, s, u, a;
    return `
        font-family: ` + (e == null || (d = e.theme) == null ? void 0 : d.components.list.UnorderedListContainer.textStyle[n].fontFamily) + `; 
        font-weight: ` + (e == null || (s = e.theme) == null ? void 0 : s.components.list.UnorderedListContainer.textStyle[n].fontWeight) + `; 
        font-size: ` + (e == null || (u = e.theme) == null ? void 0 : u.components.list.UnorderedListContainer.textStyle[n].fontSize) + `;
        line-height:  ` + (e == null || (a = e.theme) == null ? void 0 : a.components.list.UnorderedListContainer.textStyle[n].lineHeight) + `;
      `;
  } else if (n === "large") {
    var c, f, h, L;
    return `
          font-family: ` + (e == null || (c = e.theme) == null ? void 0 : c.components.list.UnorderedListContainer.textStyle[n].fontFamily) + `; 
          font-weight: ` + (e == null || (f = e.theme) == null ? void 0 : f.components.list.UnorderedListContainer.textStyle[n].fontWeight) + `; 
          font-size: ` + (e == null || (h = e.theme) == null ? void 0 : h.components.list.UnorderedListContainer.textStyle[n].fontSize) + `;
          line-height: ` + (e == null || (L = e.theme) == null ? void 0 : L.components.list.UnorderedListContainer.textStyle[n].lineHeight) + `;
      `;
  }
}, function(t) {
  var n = t.type, e = t.theme, i = t.size;
  switch (n) {
    case "bullet":
      return `
          && > li:before {
            content: ` + (e == null ? void 0 : e.components.list.UnorderedListContainer.bullet.content) + `;
            position: ` + (e == null ? void 0 : e.components.list.UnorderedListContainer.bullet.position) + `;
            left: -` + (i === "large" ? e == null ? void 0 : e.components.list.UnorderedListContainer.bullet.left.large : e == null ? void 0 : e.components.list.UnorderedListContainer.bullet.left.default) + `;
            color: ` + (e == null ? void 0 : e.components.list.UnorderedListContainer.bullet.color) + `;
          }
        `;
    case "dash":
      return `
          && > li:before {
            content: ` + (e == null ? void 0 : e.components.list.UnorderedListContainer.dash.content) + `;
            position: ` + (e == null ? void 0 : e.components.list.UnorderedListContainer.dash.position) + `;
            left: -` + (i === "large" ? e == null ? void 0 : e.components.list.UnorderedListContainer.dash.left.large : e == null ? void 0 : e.components.list.UnorderedListContainer.dash.left.default) + `;
            color: ` + (e == null ? void 0 : e.components.list.UnorderedListContainer.dash.color) + `;
          }
        `;
    case "square":
      return `
          && > li:before {
            content: ` + (e == null ? void 0 : e.components.list.UnorderedListContainer.square.content) + `;
            position: ` + (e == null ? void 0 : e.components.list.UnorderedListContainer.square.position) + `;
            left: -` + (i === "large" ? e == null ? void 0 : e.components.list.UnorderedListContainer.square.left.large : e == null ? void 0 : e.components.list.UnorderedListContainer.square.left.default) + `;
            color: ` + (e == null ? void 0 : e.components.list.UnorderedListContainer.square.color) + `;
          }
        `;
    default:
      return "";
  }
}), O = /* @__PURE__ */ g.ol.withConfig({
  displayName: "list__OrderedListContainer",
  componentId: "uv93mz-2"
})(["", ";list-style-type:", ";color:", ";", " &::marker{color:", ";font-weight:", ";}"], function(t) {
  var n = t.size, e = C(t, w);
  if (n === "small") {
    var i, o, l, r;
    return `
          font-family: ` + ((i = e.theme) == null ? void 0 : i.components.list.OrderedListContainer.textStyle[n].fontFamily) + `; 
          font-weight: ` + ((o = e.theme) == null ? void 0 : o.components.list.OrderedListContainer.textStyle[n].fontWeight) + `; 
          font-size: ` + ((l = e.theme) == null ? void 0 : l.components.list.OrderedListContainer.textStyle[n].fontSize) + `; 
          line-height: ` + ((r = e.theme) == null ? void 0 : r.components.list.OrderedListContainer.textStyle[n].lineHeight) + `;
      `;
  } else if (n === "medium") {
    var d, s, u, a;
    return `
        font-family: ` + ((d = e.theme) == null ? void 0 : d.components.list.OrderedListContainer.textStyle[n].fontFamily) + `; 
        font-weight: ` + ((s = e.theme) == null ? void 0 : s.components.list.OrderedListContainer.textStyle[n].fontWeight) + `; 
        font-size: ` + ((u = e.theme) == null ? void 0 : u.components.list.OrderedListContainer.textStyle[n].fontSize) + `;
        line-height:  ` + ((a = e.theme) == null ? void 0 : a.components.list.OrderedListContainer.textStyle[n].lineHeight) + `;
      `;
  } else if (n === "large") {
    var c, f, h, L;
    return `
          font-family: ` + ((c = e.theme) == null ? void 0 : c.components.list.OrderedListContainer.textStyle[n].fontFamily) + `; 
          font-weight: ` + ((f = e.theme) == null ? void 0 : f.components.list.OrderedListContainer.textStyle[n].fontWeight) + `; 
          font-size: ` + ((h = e.theme) == null ? void 0 : h.components.list.OrderedListContainer.textStyle[n].fontSize) + `;
          line-height: ` + ((L = e.theme) == null ? void 0 : L.components.list.OrderedListContainer.textStyle[n].lineHeight) + `;
      `;
  }
}, function(t) {
  var n = t.type;
  return n;
}, function(t) {
  var n;
  return (n = t.theme) == null ? void 0 : n.components.list.OrderedListContainer.color;
}, function(t) {
  var n = t.type, e = t.$size, i = t.theme;
  if (n === "lower-roman" || n === "upper-roman")
    return `li span.ordered {
      padding-left: ` + (i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.paddingLeft) + `;
      position: ` + (i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.position) + `;
      left: ` + (e === "small" ? i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.left.small : e === "large" ? i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.left.large : i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.left.default) + " !important;";
}, function(t) {
  var n = t.theme;
  return n == null ? void 0 : n.components.list.OrderedListContainer.marker.color;
}, function(t) {
  var n = t.$lowImpact, e = t.theme;
  return n ? e == null ? void 0 : e.components.list.OrderedListContainer.marker.fontWeight.lowImpact : e == null ? void 0 : e.components.list.OrderedListContainer.marker.fontWeight.default;
}), x = /* @__PURE__ */ g.li.withConfig({
  displayName: "list__ListItemContainer",
  componentId: "uv93mz-3"
})(["color:", ";cursor:", ";font-size:", ";line-height:", ";font-weight:", ";"], function(t) {
  var n = t.theme, e = t.$isLink;
  return e ? n == null ? void 0 : n.components.list.ListItemContainer.color.link : n == null ? void 0 : n.components.list.ListItemContainer.color.default;
}, function(t) {
  var n = t.$isLink, e = t.theme;
  return n ? e == null ? void 0 : e.components.list.ListItemContainer.cursor.link : e == null ? void 0 : e.components.list.ListItemContainer.cursor.default;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListItemContainer.fontSize;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListItemContainer.lineHeight;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListItemContainer.fontWeight;
}), k = /* @__PURE__ */ g.span.withConfig({
  displayName: "list__ListIconContainer",
  componentId: "uv93mz-4"
})(["display:", ";vertical-align:", ";margin-right:", ";"], function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListIconContainer.display;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListIconContainer.verticalAlign;
}, function(t) {
  var n;
  return t == null || (n = t.theme) == null ? void 0 : n.components.list.ListIconContainer.marginRight;
}), b = function(n) {
  var e = n.component, i = n.color;
  return /* @__PURE__ */ m(k, {
    children: /* @__PURE__ */ m(e, {
      width: "20px",
      height: "20px",
      color: i
    })
  });
}, v = function(n) {
  var e = n.children, i = n.type, o = n.onClick;
  return /* @__PURE__ */ m(x, {
    role: "listitem",
    size: i === "decimal" ? "medium" : "small",
    onClick: function(r) {
      o && o(r);
    },
    $isLink: !!o,
    children: ["decimal", "lower-alpha", "upper-alpha", "lower-roman", "upper-roman"].includes(i) ? /* @__PURE__ */ m("span", {
      className: "ordered",
      children: e
    }) : e
  });
}, E = function(n) {
  var e = n.size, i = e === void 0 ? "medium" : e, o = n.type, l = n.children, r = n.lowImpact, d = r === void 0 ? !1 : r, s = z({
    label: "List"
  }), u = ["decimal", "lower-alpha", "upper-alpha", "lower-roman", "upper-roman"].includes(o) ? y : F;
  return /* @__PURE__ */ m(U, Object.assign({
    $size: i,
    $type: o
  }, s, {
    children: /* @__PURE__ */ m(u, {
      role: "list",
      size: i,
      type: o,
      lowImpact: d,
      children: p.Children.map(l, function(a, c) {
        return a && typeof a == "string" ? /* @__PURE__ */ m(v, {
          size: i,
          type: o,
          children: a
        }, c) : a && /* @__PURE__ */ p.isValidElement(a) && a.type === v ? /* @__PURE__ */ p.cloneElement(a, {
          key: c,
          size: i,
          onClick: a.props.onClick
        }) : null;
      })
    })
  }));
}, F = function(n) {
  var e = n.type, i = n.size, o = i === void 0 ? "medium" : i, l = n.children;
  return /* @__PURE__ */ m($, {
    role: "list",
    type: e,
    size: o,
    children: p.Children.map(l, function(r, d) {
      return r && /* @__PURE__ */ p.isValidElement(r) && r.type === v ? /* @__PURE__ */ I(v, Object.assign({}, r.props, {
        size: o,
        key: d,
        type: e
      }), r.props.children) : null;
    })
  });
}, y = function(n) {
  var e = n.size, i = e === void 0 ? "medium" : e, o = n.children, l = n.type, r = l === void 0 ? "decimal" : l, d = n.lowImpact;
  return /* @__PURE__ */ m(O, {
    role: "list",
    size: i,
    type: r,
    $lowImpact: d,
    children: p.Children.map(o, function(s, u) {
      return /* @__PURE__ */ p.isValidElement(s) && s.type === v ? /* @__PURE__ */ m(v, Object.assign({
        type: r
      }, s.props, {
        children: p.Children.toArray(s.props.children)
      }), u) : /* @__PURE__ */ p.isValidElement(s) && s.type === y ? /* @__PURE__ */ m(y, {
        size: i,
        type: s.props.type,
        children: s.props.children
      }, u) : /* @__PURE__ */ m("li", {
        children: s
      }, u);
    })
  });
};
E.Item = v;
v.Icon = b;
export {
  E as List,
  b as ListIcon,
  v as ListItem
};
